import React from 'react';
import ReviewCard from '../molecules/ReviewCard';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const ReviewsSection = () => {
    return (
        <section id="reviews" className="py-24 bg-[#F9F7F2]">
            <div className="container mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="flex flex-col items-center text-center mb-16"
                >
                    <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6 border border-gray-100">
                        <div className="flex text-yellow-500">
                            <Star className="w-4 h-4 fill-current" />
                            <Star className="w-4 h-4 fill-current" />
                            <Star className="w-4 h-4 fill-current" />
                            <Star className="w-4 h-4 fill-current" />
                            <Star className="w-4 h-4 fill-current" />
                        </div>
                        <span className="text-xs font-bold uppercase tracking-widest text-gray-600">4.9/5 on Google Reviews</span>
                    </div>
                    <h2 className="serif text-4xl lg:text-5xl mb-6">Client Love Notes</h2>
                    <div className="h-1 w-20 bg-purple-200"></div>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={{
                        hidden: { opacity: 0 },
                        visible: {
                            opacity: 1,
                            transition: { staggerChildren: 0.2 }
                        }
                    }}
                    className="grid md:grid-cols-3 gap-8"
                >
                    <motion.div variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}>
                        <ReviewCard
                            name="Emily R."
                            setType="Masterpiece Set"
                            review="I’ve never had nails last this long. The 3D charms stayed on through a whole weekend at Coachella. Rich is literally a magician."
                            image="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150"
                        />
                    </motion.div>
                    <motion.div variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}>
                        <ReviewCard
                            name="Alex M."
                            setType="Elevated Set"
                            review="Finally a tech who understands modern shapes. The tapered square is sharp enough to cut glass. Obsessed is an understatement."
                            image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150"
                        />
                    </motion.div>
                    <motion.div variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}>
                        <ReviewCard
                            name="Jessica K."
                            setType="Minimalist Set"
                            review="The studio vibe is immaculate and so clean. I felt safe the entire time, and my natural nails are actually growing underneath!"
                            image="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150"
                        />
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default ReviewsSection;
